const prefix = 'component_select_report/'

const type = {
    LOAD_LIST_REPORT: prefix + 'load_list_report',
    LOAD_LIST_REPORT_SUCCESS: prefix + 'load_list_report_succes',
    UPDATE_TEXT_SEARCH: prefix + 'update_text_search',
    SEARCH_REPORT: prefix + 'search_report',

    UPDATE_SELECT_STATE_REPORT: prefix + 'update_select_state_report',
    UPDATE_SELECTED_REPORT: prefix + 'update_selected_report',

    CHANGE_PAGE_SIZE: prefix + 'change_page_size',
    CHANGE_CURRENT_PAGE: prefix + 'change_current_page',

    UPDATE_STATE: prefix + 'update_state',
    UPDATE_TIER_CREATED: prefix + 'update_tier_created'
}

const action = {
    loadListReport: params => {
        return {
            type: type.LOAD_LIST_REPORT,
            payload: {
                params
            }
        }
    },
    loadListReportSuccess: reports => {
        return {
            type: type.LOAD_LIST_REPORT_SUCCESS,
            payload: {
                reports
            }
        }
    },
    updateTextSearch: textSearch => {
        return {
            type: type.UPDATE_TEXT_SEARCH,
            payload: {
                textSearch
            }
        }
    },
    searchReport: () => {
        return {
            type: type.SEARCH_REPORT,
            payload: {

            }
        }
    },
    updateSelectStateReport: (fid, selectState) => {
        return {
            type: type.UPDATE_SELECT_STATE_REPORT,
            payload: {
                fid,
                selectState
            }
        }
    },
    updateSelectedReport: reports => {
        return {
            type: type.UPDATE_SELECTED_REPORT,
            payload: {
                reports
            }
        }
    },
    changePageSize: pageSize => {
        return {
            type: type.CHANGE_PAGE_SIZE,
            payload: {
                pageSize
            }
        }
    },
    changeCurrentPage: pageIndex => {
        return {
            type: type.CHANGE_CURRENT_PAGE,
            payload: {
                pageIndex
            }
        }
    },
    updateState: state => {
        return {
            type: type.UPDATE_STATE,
            payload: {
                state
            }
        }
    },
    updateTierCreated: tier_created => {
        return {
            type: type.UPDATE_TIER_CREATED,
            payload: {
                tier_created
            }
        }
    }
}

export default {
    type, 
    action
}